import { svgInject } from "../../Static/javascript/modules/svg-injection";
import { TobaccoWorkflowManager } from "./tobacco-workflow-manager";

$(document).ready(function () {

    // Request SVG sprite, this contains the logo image of the header
    var hash = (Math.floor(Math.random() * 1000)).toString();
    svgInject('/static/imgs/svg-sprite.svg?v=' + hash);
    // End Request SVG sprite

    (<any>window).dataLayer = (<any>window).dataLayer || [];

    // Creates a Tobacco Workflow Manager in charge of controlling 
    // all the logic of the flow.
    var formManager: TobaccoWorkflowManager = new TobaccoWorkflowManager();

    // GOOGLE ANALYTICS:
    // ----------------

    // Detecte the internet conectivity status:
    let online = 'no'
    if (navigator.onLine) {
        online = 'yes';
    }

    // When the user copy any text we send the copy text event with
    // selected text
    addEventListener('copy', function (event: ClipboardEvent) {
        const selection = window.getSelection().toString();

        (<any>window).gtag('event', 'copied_text', {
            'copied_text_chars': selection,
            'user_id': (<any>window).userId
        });

    });

    document.querySelector('.tobacco-cessation-resources-button').addEventListener('click', (evt) => {

        let target = evt.target as HTMLElement;
        const isExpanded = target.getAttribute('aria-expanded') === 'true';
        const resources = document.querySelector('.tobacco-cessation-resources');
        const resourcesContainer = document.querySelector('.tobacco-cessation-resources-container');

        if (isExpanded) {
            target.setAttribute('aria-expanded', 'false');
            resourcesContainer.setAttribute('aria-hidden', 'true');
            resources.classList.remove('open');
            document.getElementsByTagName("body")[0].classList.remove("modal-open", "resources-open");
        }
        else {
            target.setAttribute('aria-expanded', 'true');
            resources.classList.add('open');
            resourcesContainer.setAttribute('aria-hidden', 'false');
            document.getElementsByTagName("body")[0].classList.add("modal-open", "resources-open");
        }
    });

    // accordions
    addEventListener('click', (evt) => {
        const { target } = evt;
        if (target instanceof HTMLElement) {
            const classList = target.classList;

            if (classList.value == 'adage-accordion-trigger') {
                const isExpanded = target.getAttribute('aria-expanded') === 'true';
                const accordionId = target.getAttribute('aria-controls');
                const accordionPanel = document.getElementById(accordionId);

                if (isExpanded) {
                    target.setAttribute('aria-expanded', 'false');
                    accordionPanel.setAttribute('hidden', '');
                }
                else {
                    target.setAttribute('aria-expanded', 'true');
                    accordionPanel.removeAttribute('hidden');
                }
            }
        }
    });
});